import { render, staticRenderFns } from "./conversation-list.vue?vue&type=template&id=24a6af89"
import script from "./conversation-list.vue?vue&type=script&lang=js"
export * from "./conversation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a6af89')) {
      api.createRecord('24a6af89', component.options)
    } else {
      api.reload('24a6af89', component.options)
    }
    module.hot.accept("./conversation-list.vue?vue&type=template&id=24a6af89", function () {
      api.rerender('24a6af89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list-update/conversation-list.vue"
export default component.exports